module.exports = __webpack_public_path__ + "img/excel-file (SVG).6bd1d56e.svg";